import { render } from "./SignupConfirm.vue?vue&type=template&id=1dcd7d1f&scoped=true"
import script from "./SignupConfirm.vue?vue&type=script&lang=js"
export * from "./SignupConfirm.vue?vue&type=script&lang=js"

import "./SignupConfirm.vue?vue&type=style&index=0&id=1dcd7d1f&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src895191040/src/tracker-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dcd7d1f"]])

export default __exports__